/** Length of the `YYYY-MM-DD` value an `<input type="date">` reads and writes. */
export const localDateInputLength = 10;

export function toLocalDateInput(value: Date): string {
  const year = value.getFullYear();
  const month = String(value.getMonth() + 1).padStart(2, "0");
  const day = String(value.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}
